export const validateSeriesFileSizes = (d) => {
  const errors = {};
  const thumbnail = d?.thumbnail && typeof d.thumbnail.size === 'number' ? d.thumbnail : null;
  const poster = d?.poster && typeof d.poster.size === 'number' ? d.poster : null;
  const coverVideo = d?.cover_video && typeof d.cover_video.size === 'number' ? d.cover_video : null;

  if (thumbnail && thumbnail.size > 100 * 1024) {
    errors.thumbnail = 'Thumbnail must be less than 100 KB';
  }
  if (poster && poster.size > 200 * 1024) {
    errors.poster = 'Poster must be less than 200 KB';
  }
  if (coverVideo && coverVideo.size > 2 * 1024 * 1024 * 1024) {
    errors.cover_video = 'Cover video must be less than 2 GB';
  }
  return errors;
};
